import {
  faCircleCheck,
  faCircleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import {
  BodyM,
  BodyS,
  HeadlineXS,
  LabelS,
} from '#src/atoms/typography/index.tsx';
import {
  SecurityCheckTab,
  useAccountSecurityCheckContext,
} from '#src/contexts/accountSecurityCheck/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { glossary } from '#src/lib/glossary.ts';

const Badge = styled.div<{ enabled: boolean }>`
  color: ${({ enabled }) =>
    enabled ? 'var(--c-onBase-success)' : 'var(--c-red-300)'};
  display: inline-block;
  padding: 0 var(--half-unit);
  gap: var(--double-unit);
  border: solid 1px currentColor;
  border-radius: var(--half-unit);
`;
const RecoveryCodes = styled.div`
  border-top: solid 1px var(--c-nd-200);
  padding-top: var(--double-unit);
`;

export const TwoFA = () => {
  const { setSecurityCheckTab } = useAccountSecurityCheckContext();

  const { currentUser } = useCurrentUserContext();
  if (!currentUser) return null;
  const { otpRequiredForLogin } = currentUser;

  return (
    <Vertical gap={2}>
      <Vertical>
        <Horizontal>
          {otpRequiredForLogin ? (
            <FontAwesomeIcon
              icon={faCircleCheck}
              color="var(--c-onBase-success)"
            />
          ) : (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              color="var(--c-red-500)"
            />
          )}
          <HeadlineXS as="h6" color="var(--c-white)">
            <FormattedMessage defaultMessage="Two-Factor Authentication" />
          </HeadlineXS>
        </Horizontal>
        {!otpRequiredForLogin && (
          <BodyS color="var(--c-nd-600)">
            <FormattedMessage defaultMessage="Two-factor authentication (known as “2FA”) adds an extra layer of security to your account to ensure that only you have the ability to log in." />
          </BodyS>
        )}
      </Vertical>
      <div>
        <BodyM color="var(--c-white)">
          <FormattedMessage defaultMessage="Authenticator app" />
        </BodyM>
        <Badge enabled={otpRequiredForLogin}>
          <LabelS bold>
            {otpRequiredForLogin ? (
              <FormattedMessage {...glossary.enabled} />
            ) : (
              <FormattedMessage {...glossary.disabled} />
            )}
          </LabelS>
        </Badge>
      </div>
      {!!otpRequiredForLogin && (
        <RecoveryCodes>
          <BodyM color="var(--c-white)">
            <FormattedMessage defaultMessage="Recovery codes" />
          </BodyM>
          <Badge enabled>
            <LabelS bold>
              <FormattedMessage {...glossary.viewed} />
            </LabelS>
          </Badge>
        </RecoveryCodes>
      )}
      {!otpRequiredForLogin && (
        <BodyM color="var(--c-link)">
          <button
            type="button"
            onClick={() => setSecurityCheckTab(SecurityCheckTab.ENABLE_2FA)}
          >
            <FormattedMessage defaultMessage="Enable 2FA" />
          </button>
        </BodyM>
      )}
    </Vertical>
  );
};
